import store from '@/store/index'
import ask from '@/common/utils/ask'
import { universalAsk } from '@/common/utils/ask'
function is_weixin(){
  //判断是在企业微信打开 还是 在浏览器打开
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
}
const globalData = {
  $wx_config: false,
  $wx_agentConfig: false,
  $userId: '',
  $open_userid: '',
  $agentid: '',
  $corpId: '',
  $name: '',
  $avatar: '',
  $qr_code: '',
  $suiteId: 'ww7d163a0696cdc821',
  $store: store,
  $ask: ask,
  $universalAsk: universalAsk,
  $config: JSON.parse(process.env.VUE_APP_CONFIG),
  $prompt: (data) => {
    uni.showToast({
      title: data.message,
      icon:'none',
      duration: 2000
    });
  },
  $loading: (data) => {
    uni.showLoading({
      title: data.message,
      mask: data.mask || true,
    });
  },
  $hideloading: (data) => {
    uni.hideLoading();
  },
  $isQyweixin: () => {
    //判断当前入口是PC端还是APP端
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) === null ? false : true
    return flag ? (is_weixin() ? 'APP-WX' : '') : (is_weixin() ? 'PC-WX' : 'PC')
  }
}

export default globalData
